let Coder={

    OK       : 1  ,  //成功
    ERROR    : 1001,//标准错误
    ARGS_ERR : 1002,//参数错误

    POWER_ERR : 2000, //没有权限

    ERR_TERMINAL_NOT_FIND : 7000 ,//找不到终端设备

    ERR_LOGIN_ERR         : 8000, //登陆错误
    ERR_LOGIN_WAIT        : 8001, //登陆错误,错误次数过多，需要等待一段时间才能登陆
    ERR_BIND_ACC_NOT_FIND : 8002, //绑定账号不存在
    ERR_BIND_PWD          : 8003, //绑定账号密码错误
    ERR_BIND_REPEAT       : 8004, //同账号重复绑定
    ERR_BIND_BY_OTHER     : 8005, //账号被其他微信绑定
    ERR_CREATE_USER       : 8006, //创建账号错误（DB）
    ERR_CREATE_COMPANY    : 8007 //创建账号错误（DB）
  
};
export default Coder



// WEBPACK FOOTER //
// ./src/view/enum.js